'use strict'

// TODO:
// - better tooltip than plain old title attribute
// - transition to animate show/hide

Vue.component('awe-autocomplete', {
  props: {
    countries: {type: Array},
    locale: {type: String},
    limit: {type: Number, default: 5},
    allowOos: {type: Number, default: 0}
  },
  data: function(){
    return {
      geocodeTimeoutId: 0,
      places: [],
      selectedIdx: -1,
      attached: false,
      waitForPlaces: false,
      query: '',
      minLength: 3,
    }
  },
  computed: {
    hidden: function(){
      return this.places.length === 0
    }
  },
  watch: {
    // Watcher for places list
    places: function(val, oldVal){
      //  perform default selection if flag to do so was raised
      if (this.waitForPlaces & val.length > 0)
        this.selectPlace(val[0])

      this.waitForPlaces = false

      if (val.length === 0 && oldVal.length > 0 || val.length > 0 && oldVal.length === 0){
        this.$emit('ac-toggle')
      }
    }
  },
  methods: {
    request: function(query){
      if (query.length < this.minLength)
        return

      // cancel timeout if already set
      if (this.geocodeTimeoutId){
        clearTimeout(this.geocodeTimeoutId)
        this.geocodeTimeoutId = 0
      }

      this.setup()
      this.query = query

      // set timeout for geocode request
      this.geocodeTimeoutId = setTimeout(async () => {
        clearTimeout(this.geocodeTimeoutId)
        this.geocodeTimeoutId = 0

        if (!query) return

        const ac = await this._sendRequest(query)
        this.places = ac.features.map(x => Utils.parseFeature(x, 'manual', false))
        this.selectedIdx = -1
      }, 300)
    },

    // sets some dynamic CSS to position the dropdown, bind events
    setup: function(){
      if (this.attached) return

      const addressBox = this.$el.previousElementSibling.getBoundingClientRect(),
            containingBlock = this.getContainingBlock(this.$el.parentElement)

      let top = addressBox.bottom,
          left = addressBox.left

      // if there's a containing block, adjust top & left values.
      // Because getBoundingClientRect gives values relative to viewport, if there's a containing block, top & left
      // will be relative to it and not to viewport.
      if (containingBlock){
        let box = containingBlock.getBoundingClientRect()
        top -= box.top
        left -= box.left
      }

      this.$el.style.top = `${top}px`
      this.$el.style.left = `${left}px`
      this.$el.style.width = `${addressBox.width}px`

      this.$el.previousElementSibling.addEventListener('keydown', this._onkeydown)
      this.$el.previousElementSibling.addEventListener('blur', this.hide)
      this.attached = true
    },

    // find the element's containing block, i.e. the nearest ancestor whose position is not static
    getContainingBlock: function(nd){
      let res = null

      do{
        let style = window.getComputedStyle(nd)
        if (style.position != 'static')
          res = nd
        else
          nd = nd.parentElement
      }
      while (nd != null && res === null)
      return res
    },

    hide: function(e){
      this.$el.previousElementSibling.value = this.query
      this.clean()
    },

    // empty places suggestions, which hides the dropdown, and removes event listeners
    clean: function(){
      this.places = []
      this.$el.previousElementSibling.removeEventListener('keydown', this._onkeydown)
      this.$el.previousElementSibling.removeEventListener('blur', this.hide)
      this.attached = false
    },

    _onkeydown: function(evt){
      switch (evt.key) {
        case 'ArrowUp' : // arrow up
          if (this.selectedIdx > 0) {
            this.selectedIdx--
            evt.currentTarget.value = this.places[this.selectedIdx].address
            this.$emit('ac-change', {address: this.places[this.selectedIdx].address, selectedIdx: this.selectedIdx})
          }
          break
        case 'ArrowDown' : // arrow Down
          if (this.selectedIdx < this.places.length - 1) {
            this.selectedIdx++
            evt.currentTarget.value = this.places[this.selectedIdx].address
            this.$emit('ac-change', {address: this.places[this.selectedIdx].address, selectedIdx: this.selectedIdx})
          }
          break
        case 'Escape': // escape
          this.hide()
          break
        case 'Enter' : // Enter
          if (this.selectedIdx === -1)
            this.selectedIdx = 0

          let selected = this.places[this.selectedIdx]

          if (!selected){
            // if no places to select, set flag to select a place when places array is updated
            this.waitForPlaces = true
            return
          }

          this.selectPlace(selected)
          break
      }
      evt.stopPropagation()
    },

    selectPlace: async function(place){
      // No zipcode ? run reverse geocoding on selection coordinates
      if (!place.zipCode){
        const newPlace = await Utils.getReverseGeocoding(place.longitude, place.latitude, this.countries, this.locale, 'manual', false)
        place.zipCode = newPlace.zipCode
      }

      this.$emit('location-update', place)
      this.clean()
    },

    // sends geocode request and returns the response parsed as JSON
    _sendRequest: async function(query){
      try{
        let qs = `language=${this.locale}&limit=${this.limit}&access_token=pk.eyJ1Ijoic3dhdmVuIiwiYSI6ImNqbTd1dXBlcjFhejMzcHBvajVlYjFjMXcifQ.ljVSrON2CjvnSj38Nxa9RA`

        if ((this.allowOos & OosLevels.ALLOW) !== OosLevels.ALLOW)
          qs += '&country=' + this.countries.join(',')

        const res = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${query}.json?${qs}`)
        return res.json()
      }
      catch(err){
        console.error(err)
        return {features: []}
      }
      finally {
        // track mapbox usage
        Tracker.log('mapbox-request', { api: 'geocode', query })
      }
    },

    _onmouseover: function(idx, evt){
      this.selectedIdx = idx
      this.$el.previousElementSibling.value = evt.currentTarget.innerText
      this.$emit('ac-change', {address: evt.currentTarget.innerText, selectedIdx: idx})
    },

    _onmousedown: function(idx){
      var selected = this.places[idx]
      this.selectPlace(selected)
    }
  },

  template: `
    <ol id="_autocomplete" :class="{ hidden: hidden }" role="listbox">
      <li v-for="(p, _i) in places" :title="p.address" role="option"
        :class="{selected: _i === selectedIdx, 'ac-row': 1}"
        v-on:mouseover="_onmouseover(_i, $event)" v-on:mousedown="_onmousedown(_i)"
        :aria-selected="_i === selectedIdx"
        :id="'suggestion-' + _i"
      >
      {{ p.address }}
      </li>
    </ol>`
})

